<p-panel header="{{ 'fs.res.common.doctorates' | hisUi }}">
	<div class="infoMessage" *ngIf="!getSelectedDoctorates() || getSelectedDoctorates().length === 0">
		{{ 'fs.res.common.doctorate.noDoctorateAssigned' | hisUi }}
	</div>
	<button *ngIf="!getIsAddDoctorate()" (click)="setIsAddDoctorate()" hisImage="plus_circ_green" class="transparent"><span>{{ 'fs.res.common.doctorate.addDoctorate' | hisUi }}</span></button>
	<div *ngIf="getIsAddDoctorate()">
		<p-autoComplete [hisDdKey]="dDKey" #content
			[(ngModel)]="selectedDoctorate"
			[suggestions]="filteredDoctorate"
			field="label"
			[size]="30"	[minLength]="1"
		    [forceSelection]="true"
			class="autocompleteWidth60"
			(completeMethod)="filterDoctorate($event)"
			(onSelect)="addDoctorate()">
		</p-autoComplete>
		<div class="clearer"></div>
	</div>
	<div *ngIf="getSelectedDoctorates() && getSelectedDoctorates().length > 0">
		<div class="clearAndSpace"></div>
		<p-table [value]="getSelectedDoctorates()">
		    <ng-template pTemplate="header">
				        <tr>
				            <th>{{'fs.res.doctoral.Habilitation.edit.title' | hisUi}}</th>
				            <th>{{'fs.res.doctoral.habilitation.student' | hisUi}}</th>
				            <th>{{'fs.res.doctoral.habilitation.supervisor' | hisUi}}</th>
				            <th>{{'common.actions' | hisUi }}</th>
		        </tr>
		    </ng-template>
		    <ng-template pTemplate="body" let-index="rowIndex" let-habilitation>
		        <tr>
		            <td>{{habilitation.title}}</td>
		           	<td>
						{{habilitation.person.surname}}, {{habilitation.person.firstname}}<br/>
			        </td>
		            <td>
						<span *ngFor="let docent of habilitation.docents">
							<span *ngIf="docent.hiskeyId >= 3">
								{{docent.surname}}, {{docent.firstname}}<br/>
							</span>
						</span>
			        </td>
		            <td class="singleLine">
			        	<!-- <a routerLink="/pub/project/view/{{project.id}}" hisImage="MAGNIFIER_DETAIL" [title]="'de.his.javang.show' | hisUi"></a> -->
			        	<button (click)="deleteDoctorate(index)" hisImage="DELETE" class="icon"
			        	    title="{{'common.removeAssignmentOf' | hisUi:(habilitation.title)}}">
			        	</button>
			       </td>
			    </tr>
			</ng-template>
		</p-table>
	</div>
</p-panel>
